<div class="google-places-autocomplete" [class]="className" (document:click)="handleClickOutside($event)" role="combobox" aria-autocomplete="list"
  [attr.aria-expanded]="showSuggestions" aria-controls="google-places-listbox" aria-haspopup="listbox">
  <ion-searchbar #input type="text" mode="md" data-cy="searchArea" [(ngModel)]="inputValue"
    (ionInput)="handleInputChange($event.detail.value!)" (click)="handleInputClick($event)" [placeholder]="placeholder"
    [class]="'google-places-input ' + inputClassName" [debounce]="500"></ion-searchbar>

  <div #suggestionsElement *ngIf="showSuggestions && suggestions.length > 0"
    [class]="'google-places-suggestions ' + suggestionsClassName" id="google-places-listbox" role="listbox">
    <ng-container *ngFor="let suggestion of suggestions">
      <div class="suggestion-item" data-cy="suggestionItem"
        (click)="handleSuggestionClick(suggestion?.placePrediction?.placeId || '')" role="option" tabindex="0" 
        [attr.aria-label]="suggestion?.placePrediction?.mainText + ', ' + suggestion?.placePrediction?.secondaryText">
        <div class="icon">
          <ion-icon aria-hidden="true" name="location-outline"></ion-icon>
        </div>
        <div class="text">
          <div class="main-text">{{ suggestion?.placePrediction?.mainText }}</div>
          <div class="secondary-text">{{ suggestion?.placePrediction?.secondaryText }}</div>
        </div>
      </div>
    </ng-container>
  </div>
</div>